function c(e) {
  return {
    ...e,
    pos: e.pos.slice(),
    rot: e.rot.slice(),
    anchor: e.anchor.slice(),
    size: e.size.slice(),
    data: { ...e.data },
    children: e.children.map(c)
  };
}
export {
  c as RgShallowClone
};
//# sourceMappingURL=index29.js.map
